import React from "react"
import clsx from "clsx"
import SurveyFormFileUploadBuilder from "../SurveyFormFileUploadBuilder/SurveyFormFileUploadBuilder"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
class EmailedAgreementForm extends React.Component {

  constructor(props) {
    super(props)
    this.state ={
      loading: false,
      step: 'start',
      position: 1,
      order: this.props.order ? this.props.order : [],
      answers: [],
      file_upload_group: [{ file_uploads: [] }],
      customer_image_form_field_id: '',
      currentStepId: '',
    }
    this.onChangeStep = this.onChangeStep.bind(this)
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this)
    this.onChangeFormFields = this.onChangeFormFields.bind(this)
  }

  // *** Life cycle methods *** //

  componentDidUpdate(nextProps, nextState) {
    const required_field_ids = []
    const required_fields = this.props.form_fields.filter(field => field.required == true);
    required_fields.map((field) => {
      required_field_ids.push(field.id)
    })
    var step = ''

    if(this.state.answers.length >= required_fields.length) {
      step = 'submit'
    }

    if(this.state.answers.length < required_fields.length && this.state.answers.length > 0) {
      step = 'continue'
    }

    if(this.state.answers.length < 1) {
      step = 'start'
    }

    if(step != this.state.step) {
      this.setState({step: step})
    }

    if(step == 'continue' && step != this.state.step) {
      this.setState({started: new Date()})
    }

    if(step == 'submit' && step != this.state.step) {
      this.setState({ended: new Date(), started: new Date()})
    }
  }


  // *** Render functions *** // 

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'document_preview',
      'tab-pane': true
    });

    return (
      <div className={this.props.insideTab == true ? tabClasses : ""} id="preview">
        <div className="OrderFormBuilder">
          <div className="panel" style={{position: 'sticky', top: '0px', backgroundColor:'#ededed', zIndex:'99', boxShadow: "3px 3px 7px rgba(0, 0, 0, 0.2)", marginBottom: '5px'}}>
            <div className="panel-body container">
              <div className="flexed">
                <div className="col-md-8" style={{padding:'0px'}}>
                  <h3 className="panel-heading-text col-md-8" style={{padding:'1rem 1rem 0px'}}>{this.props.title}</h3>
                  <p className="panel-heading-text col-md-12" style={{padding:'.5rem 1rem 0px', marginBottom:'1rem', borderBottom: 'none', fontSize: '11px'}}>{this.props.check_in_info}</p>
                </div>
                <div key="add-button" className="col-md-4 content-right flexed" style={{ marginBottom: 15, paddingRight: '0px', paddingTop: '10px' }}>
                  {this.props.reservation_segment_id == null && this.state.step == 'submit'
                  ?
                    <button type="submit" style={{opacity: '.65' }} disabled title={I18n.t("test_forms_cannot_be_saved")} className="btn btn-primary btn-sm">{I18n.t('submit')} </button>
                  :
                    <button onClick={this.state.step != 'submit' ? () => this.onChangeStep(this.state.step) : e => this.onSubmit(e)} type="button" className="btn btn-primary btn-sm" style={{height: '2.65em'}}>{I18n.t(this.state.step)}</button>
                  }
                </div>
              </div>
              {this.state.step == 'submit' 
              ? 
                <div className="TermsAndConditions content-right flexed">
                  <label>
                    {this.props.helper_template != null 
                    ?       
                      <a className="modal-iframe" href={this.props.form_terms_path ? this.props.form_terms_path : '#'} style={{textDecoration: 'underline', color: '#2495f3'}}>{I18n.t("i_agree_to_terms_and_conditions")}</a>
                    :
                      <span dangerouslySetInnerHTML={{__html: I18n.t('i_agree_with_user_terms')}}></span>
                    }
                  </label>
                </div>
              : 
                null
              }
            </div>
          </div>
          <div className="container" style={{padding:'0px'}}>
            {this.renderHeaderErrors()}
            {this.renderFormFields(this.props.form_fields)}
            <LoadingSpinner show={this.state.loading} style={{position: "fixed"}} />
          </div>
        </div>
      </div>
    )
  }

  renderFormFields(form_fields) {
    var formFields = form_fields.sort((a, b) => a.position - b.position).map((form_field) => {
      var form_field_answer = null
      var display_only_answer = null
      var image_answer = null

      if(this.state.answers) {
        var customerAnswers = this.state.answers
        customerAnswers.map((answer) => {
          if(answer.form_field_id == form_field.id){
            if(answer.display_only_answer == true) {
              display_only_answer = answer.display_only_answer
            } else if (answer.image_answer) {
              image_answer = answer.image_answer
            } else {
              form_field_answer = answer.answer         
            }
          }
        })
      }

      if(form_field.field_type == "display_only") {
        if(form_field.required == true) { 
          return (
            <div className="row" key={form_field.id}>
              <div className="col-lg-12" id={form_field.id} style={this.state.currentStepId == form_field.id ? {border: `1px solid ${this.props.property_button_background_color}`, paddingBottom: '10px'} : {paddingBottom: '10px'}}>
                <div className="form-group">
                  <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  <div dangerouslySetInnerHTML={{ __html: form_field.display_only_text }}></div>
                  <label style={display_only_answer == true ? {paddingTop:'5px', float:'right', fontFamily:'cursive'} : {paddingTop:'5px', float:'right'}}>
                    <input className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "has-errors" : ""} type="checkbox" name={form_field.field_type} disabled={display_only_answer == true ? true : false} id={form_field.id} onChange={this.onChangeFormFields} />
                    {` ${display_only_answer == true ? this.props.initials ? this.props.initials : "TC" : I18n.t('agree')}`}
                  </label>
                  {this.renderFieldErrors(form_field.field)}
                </div>
                <br></br>
              </div>
            </div>
          )
        } else {
          return (
            <div className="row" key={form_field.id}>
              <div className="col-lg-12" id={form_field.id} style={{paddingBottom: '10px' }}>
                <div className="form-group">
                  <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  <div dangerouslySetInnerHTML={{ __html: form_field.display_only_text }}></div>
                </div>
                <br></br>
              </div>
            </div>
          )
        }
      }

      if(form_field.field_type == "signature_generator") {
        return (
          <div className="row" key={form_field.id} >
            <div className="col-lg-12" id={form_field.id} style={this.state.currentStepId == form_field.id ? {border: `1px solid ${this.props.property_button_background_color}`, paddingBottom: '10px'} : {paddingBottom: '10px'}}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <input className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.onChangeFormFields} placeholder={this.props.customer ? `${this.props.customer.first_name} ${this.props.customer.last_name}` : I18n.t('placeholder') } />
                <br></br>
                <textarea className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "form-control signature-generator has-errors" : "form-control signature-generator"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} style={{fontFamily: 'cursive', fontSize: 'larger', textAlign: 'center'}} readOnly={true}/>
                {this.renderFieldErrors(form_field.field)}
              </div>
              <br></br>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "image") {
        return(
          <div className="row" key={form_field.id}>
            <div className="col-lg-12" id={form_field.id} style={this.state.currentStepId == form_field.id ? {border: `1px solid`, paddingBottom: '10px'} : {paddingBottom: '10px'}}>
              <div className="form-group">
                <SurveyFormFileUploadBuilder nested={true} read_only={false} onChange={this.props.onChangeFileUploadGroup ? this.props.onChangeFileUploadGroup : this.onChangeFileUploadGroup} file_upload_groups={image_answer ? image_answer : [{ file_uploads: [] }]} singleFile={true} form_field_id={form_field.id} form_field={form_field} />
              </div>
              <br></br>
            </div>   
          </div>
        )
      }
    });

    return (
      <div key={this.props.id}>
          <div className="container" style={{ background: '#EFEFEF', paddingTop: '10px', height: 'auto', paddingLeft: '0px', paddingRight:'0px', paddingBottom: "5px"}}>
            <div className="row center_1">
              <div className="text-center col-md-12">
                <img className="logo_image" src={this.props.logo_image_url} style={{width: 200, height: 'auto'}}></img> 
              </div>
            </div>
            <div className="row center_1">
              <div className="text-center col-md-12">
                <label className="label_style">{this.props.property_name}</label>
              </div>
            </div>
            <div className="row center_1">
              <div className="text-center col-md-12">
                <label className="label_style">{this.props.property_address}</label>
              </div>
            </div>
          </div>
          <div style={{paddingTop: '20px', paddingRight: '30px', paddingLeft: '30px'}}>
            {formFields}
          </div>
      </div>
    );
  }

  // *** Change Handlers *** //
  
  onChangeStep = (step) => {
    const required_field_ids = []
    const required_fields = this.props.form_fields.filter(field => field.required == true);
    required_fields.map((field) => {
      required_field_ids.push(field.id)
    })
    const answersFilledArray = []

    this.state.answers.map((answer) => {
      if(answer.answer || answer.display_only_answer || answer.image_answer) {
        answersFilledArray.push(answer.form_field_id)
      } 
    })

    if (step == 'start') {
      document.getElementById(required_field_ids[0]).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      this.setState({
        step: 'continue',
        started: new Date(),
        currentStepId: required_field_ids[0]
      })
    }

    if (step == 'continue') {
      if (answersFilledArray.length < required_field_ids.length) {
        required_field_ids.forEach((field, idx) => {
          if(answersFilledArray.includes(field)) {
            if(idx < required_field_ids.length - 1) {
              document.getElementById(required_field_ids[idx + 1]).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});     
              this.setState({
                step: 'continue',
                currentStepId: required_field_ids[idx + 1],
              })
              return
            } else if(idx == required_field_ids.length - 1) {
              const notAnsweredFields = required_field_ids.filter(field => !answersFilledArray.includes(field));
              document.getElementById(notAnsweredFields[0]).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"}); 
              this.setState({
                step: 'continue',
                currentStepId: notAnsweredFields[0],
              })
              return
            }

          } 
        })
      } else if(answersFilledArray.length == required_field_ids.length) {
        this.setState({
          step: 'submit',
          ended: new Date(),
        })
      } 

    }

  }

  onChangeFormFields(e) {
    var answers = this.state.answers
   
      this.props.form_fields.map((field) => {
        if(field.id === e.target.id) {
          var found = false;
          if(answers) {
            for(var i = 0, ilen = answers.length; i < ilen; i++) {
              if (answers[i].form_field_id === e.target.id) {
                found = true;
                break;
              }
            }
          }

          if (found) {
            answers.map(answer => {
              if (answer.form_field_id === e.target.id) {
                if(e.target.name == "display_only") {
                  answer.display_only_answer = !answer.display_only_answer
                } else {
                  answer.answer = e.target.value
                  if (e.target.value == "") {
                    answers.splice(answers.indexOf(answer), 1)
                    
                  }
                }
              }
            })
          } else {
            if(!answers) {
              answers = []
            }

            if(e.target.name == "display_only") {
              var new_answer = {
                form_field_id: e.target.id,
                display_only_answer: true,
              }
            } else {   
              var new_answer = {
                form_field_id: e.target.id,
                answer: e.target.value,
              }
            }

            answers.push(new_answer)
          }
        }
      })
    
    this.setState({answers: answers})
  }

  onChangeFileUploadGroup(file_upload_group, form_field_id) {
    var answers = this.state.answers
    this.props.form_fields.map((field) => {
      if(field.id === form_field_id) {
        var found = false;

        if(answers) {
          for(var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === form_field_id) {
              found = true;
              break;
            }
          }
        }

        if (found) {
          answers.map(answer => {
            if (answer.form_field_id === form_field_id) {
              answer.image_answer = [file_upload_group]

            }
          })
        } else {
          if(!answers) {
            answers = []
          } else {   
            var new_answer = {
              image_answer: [file_upload_group],
              form_field_id: form_field_id,
            }
          }
          answers.push(new_answer)
        }
      } else if(form_field_id == null) {
        answers = answers.filter(answer => !answer.image_answer)
      }
    })
    this.setState({answers: answers})
  }

    // *** Error Handling ** //

    renderFieldErrors(key, numberSpinner) {
      if (this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[key]) {
        var error = this.state.errors.field_errors[key][0]

        if(numberSpinner == true) {
          return (
            <div className="help-block">
              <ul><li style={{textAlign: "left"}}><b>&#x2022;</b>{error}</li></ul>
            </div>
          );
        } else {
          return (
            <div className="help-block">
              <ul><li><b>&#x2022;</b>{error}</li></ul>
            </div>
          );
        };
      };
  
    }
  
    renderHeaderErrors() { 
      if (this.state.errors && this.state.errors.header_errors) {
        var errors = this.state.errors.header_errors.map((error, idx) => <li key={idx}>{error}</li>)
        return (
          <div className="alert alert-danger">
            <ul>{errors}</ul>
          </div>
        );
      };
    }
  
    renderFieldClasses(field, noFormControl) {
      if (noFormControl === true) {
        var classname = ''
      } else {
        var classname = 'form-control';
      }
      if(this.state.errors && this.state.errors.header_errors){
  
        this.state.errors.header_errors.forEach((error) => {
          if (error == `${this.capitalizeFirstLetter(field)} can't be blank `) {
            classname = classname + ' has-errors'   
          }
        })   
        return classname
      }
    }

    // *** Helper Functions *** //

    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    // *** AJAX Calls *** //

    onSubmit() {
      var self = this  
      self.setState({ loading: true})
      setTimeout(function () {
        $.ajax({
          type: 'POST',
          url: self.props.document_answers_save_path,
          data: {
            answers: self.state.answers ? JSON.stringify(self.state.answers) : null,
            reservation_segment_id: self.props.reservation_segment_id,
            form_started: self.state.started,
            form_completed: self.state.ended,
            document_form_id: self.props.id,
            check_in_process: self.props.check_in_process,
          },
        }).done(function (data) { 
          if (data && data.errors) {
            self.setState({errors: data.errors, success: null, loading: false});
          } else {
            
            if (parent && parent.refresh_data) {
              if (self.props.is_new == true) {
                parent.refresh_data(I18n.t('form_created_successfully'));
              } else {
                parent.refresh_data(I18n.t('form_saved_successfully'));
              }
            }

            if(!data.errors && self.props.check_in_process == true) {
              var steps = self.props.steps
              steps.shift()
              // console.log("steps1", steps)
              parent.window.refresh_data()
              self.props.isAgreementFormCompleted(steps)
              self.props.onGotoStep(steps[0])
            } else {
              if (parent && parent.hide_modal) {
                parent.hide_modal()
              }
              window.location.href = '/portal/document-completion'

            }
          }
        })
      }, 1000)
    };

  
}

export default EmailedAgreementForm